import { render, staticRenderFns } from "./homeParam.vue?vue&type=template&id=1a513055&scoped=true"
import script from "./homeParam.vue?vue&type=script&lang=js"
export * from "./homeParam.vue?vue&type=script&lang=js"
import style0 from "./homeParam.vue?vue&type=style&index=0&id=1a513055&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a513055",
  null
  
)

export default component.exports